import * as React from 'react';
import classNames from 'classnames';
import * as Classes from '../common/classes';
import { BaseProps } from '../common/props';

export interface IFormGridProps extends BaseProps {
  size?:
    | undefined
    // @deprecated
    | 'sm'
    | 'md'
    | 'lg'
    | 'xl'
    | 'xxl'
    | 'dblCol';
}

export type FormGridProps = IFormGridProps;

export const getFormGridClassNames = (
  size?:
    | undefined
    // @deprecated
    | 'sm'
    | 'md'
    | 'lg'
    | 'xl'
    | 'xxl'
    | 'dblCol'
    | 'dynamic'
) => {
  if (size === 'dynamic') {
    return classNames({});
  } else {
    return classNames(Classes.FORM_GRID, {
      [Classes.FORM_GRID_SIZE_DEFAULT]: !size || size === 'sm',
      [Classes.FORM_GRID_SIZE_MD]: size === 'md',
      [Classes.FORM_GRID_SIZE_LG]: size === 'lg',
      [Classes.FORM_GRID_SIZE_XL]: size === 'xl',
      [Classes.FORM_GRID_SIZE_XXL]: size === 'xxl',
      [Classes.FORM_GRID_SIZE_DBLCOL]: size === 'dblCol',
    });
  }
};

/**
 * Komponenta wrapperu pro standardní grid ve formulářích - pro zajištění stejné výchozí šířky buňky pro různé velikosti gridu (pro velikosti gridů je pak použit jiný počet sloupců).
 * Small: 6
 * Default: 12
 * Large: 18
 * Extra large: 26
 */
export class FormGrid extends React.PureComponent<FormGridProps> {
  render() {
    const { className, style, children, size, ...other } = this.props;

    let cls = classNames(
      getFormGridClassNames(size),
      Classes.EDIT_MODE,
      className
    );

    return (
      <div {...other} className={cls} style={style}>
        {children}
      </div>
    );
  }
}
